import { relations } from 'drizzle-orm'
import {
  boolean,
  index,
  pgEnum,
  pgTable,
  text,
  unique,
} from 'drizzle-orm/pg-core'
import {
  getBaseFields,
  getBaseIndexes,
  getIdReference,
  getNullableIdReference,
  getTimestampWithTimezone,
} from '../common/utils'
import { users } from './user'
import { visits } from './visit'

export const preInfoSourceEnum = pgEnum('pre_info_source', [
  'form',
  'phone',
  'email',
])

export const ventilationPlansDeliveryEnum = pgEnum(
  'ventilation_plans_delivery',
  ['uploaded', 'onsite'],
)

/**
 * One pre-visit questionnaire per visit. Holds the request/answer/review
 * lifecycle and the answers that are about this visit (access, plans
 * delivery, free text); the durable facts about the house (unit model, plans,
 * access notes) live on `properties.ventilation` because they don't change
 * between years.
 */
export const visitPreInfos = pgTable(
  'visit_pre_infos',
  {
    ...getBaseFields(),
    visitId: getIdReference(() => visits.id),
    requestedAt: getTimestampWithTimezone(),
    submittedAt: getTimestampWithTimezone(),
    submittedVia: preInfoSourceEnum(),
    accessConfirmed: boolean(),
    plansDelivery: ventilationPlansDeliveryEnum(),
    notes: text(),
    internalReviewedAt: getTimestampWithTimezone(),
    internalReviewedBy: getNullableIdReference(() => users.id),
    internalReviewComment: text(),
  },
  (table) => [
    ...getBaseIndexes('visit_pre_infos', table),
    unique('visit_pre_infos_visit_id_unique').on(table.visitId),
    index('visit_pre_infos_submitted_at_idx').on(table.submittedAt),
  ],
)

export const visitPreInfosRelations = relations(visitPreInfos, ({ one }) => ({
  visit: one(visits, {
    fields: [visitPreInfos.visitId],
    references: [visits.id],
  }),
  internalReviewedByUser: one(users, {
    fields: [visitPreInfos.internalReviewedBy],
    references: [users.id],
  }),
}))
